import React from 'react';

import gridWidth from '../shared/grid-width';

import type {
  PrismicRichContent,
  PrismicImage,
  PrismicSliceImage,
} from '../../../../../types';

import * as S from './styles';

type Props = {
  text: Array<PrismicRichContent>;
  image: PrismicImage;
  reverse?: boolean;
  gridLayout: string;
} & Pick<PrismicSliceImage, 'image' | 'imageLinkOrPath'>;

const ImageText = ({
  text,
  image,
  reverse = false,
  gridLayout,
  imageLinkOrPath,
}: Props) => {
  const width = gridWidth(gridLayout);
  const properties = {
    image,
    imageLinkOrPath,
  };
  return (
    <S.ImageText reverse={reverse}>
      <S.Image
        {...properties}
        width={width[reverse ? 1 : 0]}
        reverse={reverse}
      />
      <S.Text data={text} width={width[reverse ? 0 : 1]} reverse={reverse} />
    </S.ImageText>
  );
};

export default ImageText;
